import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=5654ecb0"
import script from "./DashboardHeader.vue?vue&type=script&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&lang=js"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=5654ecb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports